var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.746,
    height: 45.49,
    viewBox: "0 0 50.746 45.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6449",
    "data-name": "Group 6449",
    transform: "translate(-399 -553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6448",
    "data-name": "Group 6448",
    transform: "translate(399 553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15653",
    "data-name": "Path 15653",
    d: "M110.355,24.133a1.487,1.487,0,0,0-2.1.13l-.024.027V23.248a22.756,22.756,0,0,0-33.3-20.16A22.938,22.938,0,0,0,67,9.981a1.487,1.487,0,0,0,2.414,1.736,19.776,19.776,0,0,1,35.84,11.532V24.29l-.024-.027a1.487,1.487,0,1,0-2.229,1.968l2.625,2.972a1.487,1.487,0,0,0,2.229,0l2.625-2.972a1.487,1.487,0,0,0-.13-2.1Zm0,0",
    transform: "translate(-60.111 -0.5)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15654",
    "data-name": "Path 15654",
    d: "M43.513,182.455a1.487,1.487,0,0,0-2.075.339A19.776,19.776,0,0,1,5.6,171.262V170.22l.024.027a1.487,1.487,0,0,0,2.229-1.969l-2.625-2.972a1.487,1.487,0,0,0-2.229,0L.371,168.279A1.487,1.487,0,1,0,2.6,170.248l.024-.027v1.042a22.756,22.756,0,0,0,33.3,20.16,22.944,22.944,0,0,0,7.932-6.892,1.486,1.486,0,0,0-.339-2.075Zm0,0",
    transform: "translate(0.001 -148.52)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Open_book",
    "data-name": "Open book",
    transform: "translate(410.795 565.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6447",
    "data-name": "Group 6447",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6446",
    "data-name": "Group 6446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15656",
    "data-name": "Path 15656",
    d: "M35.8,35.049h0a.96.96,0,0,0-.682.283.97.97,0,0,0-.287.691v14.6a.977.977,0,0,0,.975.973c2.266.005,6.064.478,8.683,3.219V39.536a.933.933,0,0,0-.134-.493C42.207,35.58,38.076,35.054,35.8,35.049Z",
    transform: "translate(-31.642 -35.049)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15657",
    "data-name": "Path 15657",
    d: "M166.409,50.622v-14.6a.97.97,0,0,0-.287-.691.96.96,0,0,0-.682-.283h0c-2.271.005-6.4.531-8.553,3.994a.933.933,0,0,0-.134.493v15.28c2.62-2.741,6.417-3.214,8.683-3.219A.977.977,0,0,0,166.409,50.622Z",
    transform: "translate(-142.39 -35.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15658",
    "data-name": "Path 15658",
    d: "M182.008,71.8H181.3V84.008a2.491,2.491,0,0,1-2.483,2.485c-1.922,0-5.092.38-7.337,2.505a23.44,23.44,0,0,1,10.308.2.974.974,0,0,0,1.191-.949V72.775A.975.975,0,0,0,182.008,71.8Z",
    transform: "translate(-155.771 -68.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15659",
    "data-name": "Path 15659",
    d: "M1.68,84.008V71.8H.974A.975.975,0,0,0,0,72.775V88.248a.974.974,0,0,0,1.191.949A23.438,23.438,0,0,1,11.5,89c-2.245-2.125-5.415-2.5-7.337-2.5A2.491,2.491,0,0,1,1.68,84.008Z",
    transform: "translate(0 -68.434)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCipIcon);
export default __webpack_public_path__ + "static/media/cipIcon.dbeacd10a207cdcb45e13b4e2e08f1c0.svg";
export { ForwardRef as ReactComponent };